export default {
  success: 200,
  created: 201,
  notFound: 404,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  conflict: 409,
  internalServerError: 500,
};